import { DocumentTypeLicenseEnum } from "@core/domain/models/inc-document.model";

export class DocumentLicenseType {
    constructor(
        public readonly type: DocumentTypeLicenseEnum,
        public readonly label: string,
    ) {}
}
